export default __webpack_public_path__ + "static/media/bgc.72d906c2.png";